import { http, HttpResponse } from 'msw';

import {
  AccountChangeDescriptionRequest,
  AccountChangeDescriptionResponse,
  AccountChangeUserNameRequest,
  AccountChangeUserNameResponse,
} from '~/server/src/dtos';

import { getAccount, putAccountDescription, putAccountUsername } from './apiAccount';
import { users } from './apiMockData';

const account = users[users.length / 2];

const accountHandlers = [
  http.get(getAccount, () => {
    return HttpResponse.json(account);
  }),

  http.put(putAccountUsername, async ({ request }) => {
    const { username } = (await request.json()) as AccountChangeUserNameRequest;
    account.username = username;

    const response: AccountChangeUserNameResponse = { username };
    return HttpResponse.json(response);
  }),

  http.put(putAccountDescription, async ({ request }) => {
    const { description } = (await request.json()) as AccountChangeDescriptionRequest;
    account.description = description;

    const response: AccountChangeDescriptionResponse = { description };
    return HttpResponse.json(response);
  }),
];

export default accountHandlers;
